import { object, string } from "zod"
import { CONFIRM_NEW_PASSWORD, CURRENT_PASSWORD, MINIMUM_PASSWORD_LENGTH, MINIMUM_USERNAME_LENGTH, NEW_PASSWORD, OTP_LENGTH } from "constants/index"

export const loginUserSchema = object({
  username: string().min(1, "Username is required"),
  password: string().min(1, "Password is required")
})

const usernameRegex = /^[a-zA-Z0-9._-]+$/

export const registerUserSchema = object({
  email: string()
    .min(1)
    .refine(value => {
      return String(value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    }),
  username: string()
    .min(MINIMUM_USERNAME_LENGTH, `Username should be at least ${MINIMUM_USERNAME_LENGTH} characters`)
    .refine((val) => usernameRegex.test(val), "Username can not contain Persian characters"),
  password: string()
    .min(MINIMUM_PASSWORD_LENGTH, `Password should be at least ${MINIMUM_PASSWORD_LENGTH} characters`),
  confirmPassword: string()
}).refine(
  (values) => {
    return values.password === values.confirmPassword
  },
  {
    message: "Passwords must match!",
    path: ["confirmPassword"]
  }
)

export const sendOTPEmailSchema = object({
  email: string()
    .min(1)
    .refine(value => {
      return String(value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    })
})

export const resetPasswordSchema = object({
  otp: string().length(OTP_LENGTH),
  [NEW_PASSWORD]: string()
    .min(MINIMUM_PASSWORD_LENGTH, `Password should be at least ${MINIMUM_PASSWORD_LENGTH} characters`),
  [CONFIRM_NEW_PASSWORD]: string()
}).refine(
  (values) => {
    return values[NEW_PASSWORD] === values[CONFIRM_NEW_PASSWORD]
  },
  {
    message: "Passwords must match!",
    path: [CONFIRM_NEW_PASSWORD]
  }
)

export const changePasswordSchema = object({
  [CURRENT_PASSWORD]: string(),
  [NEW_PASSWORD]: string()
    .min(MINIMUM_PASSWORD_LENGTH, `Password should be at least ${MINIMUM_PASSWORD_LENGTH} characters`),
  [CONFIRM_NEW_PASSWORD]: string()
}).refine(
  (values) => {
    return values[NEW_PASSWORD] === values[CONFIRM_NEW_PASSWORD]
  },
  {
    message: "Passwords must match!",
    path: [CONFIRM_NEW_PASSWORD]
  }
)
